import React, { useEffect, useState } from "react";
import { Logo } from "src/assets/images";
import { popularTwo } from "src/assets/images";
// import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import * as yup from "yup";
import { renderErrorMessage, renderSuccessMessage } from "src/assets/functions";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { Formik, ErrorMessage } from "formik";
import { signUp } from "src/api";
import { BsEye, BsEyeSlash } from "react-icons/bs";
// import Loader from "src/components/Loader";



const Register = () => {
    const navigate = useNavigate();
    // const { setUser, setToken } = useProtectedRoutesContext();
    const [visible, setVisible] = useState(false);
    const [visible1, setVisible1] = useState(false);
    // const [isPageLoading, setIsPageLoading] = useState(true);


    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setIsPageLoading(false);
    //     }, 300);
    //     return () => clearTimeout(timer);
    // }, []);

    // if (isPageLoading) return <Loader />;

    const initialValues = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmpassword: "",
    };


    const { mutate, isLoading } = useMutation(signUp, {
        onSuccess: (data) => {
            renderSuccessMessage(data.message);
            navigate(`/login`);
            // navigate(`/checkemail`);
        },
        onError: (error) => renderErrorMessage(
            error.message
        ),
    });


    const validationSchema = yup.object().shape({
        email: yup
            .string()
            .email("Please provide a valid email")
            .required("Please provide a valid email"),
        firstName: yup.string().required("Please enter your Firstname"),
        lastName: yup.string().required("Please enter your Lastname"),
        password: yup
            .string()
            .required("Password is required")
            .min(8, "Password must be 8 characters long"),
        // .matches(/[0-9]/, "Password requires a number")
        // .matches(/[a-z]/, "Password requires a lowercase letter")
        // .matches(/[A-Z]/, "Password requires an uppercase letter"),
        // .matches(/[^\w]/, "Password requires a symbol"),
        confirmpassword: yup
            .string()
            .required("Confirm your password")
            .oneOf([yup.ref("password"), null], "Passwords don't match"),
    });


    return (
        <div className="flex min-h-screen">
            {/* Left Section - col-lg-4 */}
            <div className="w-full lg:w-1/3 flex flex-col  items-center p-10">
                {/* Logo */}
                <a href="/"><img src={Logo} alt="Logo" className="w-[120px] mb-[35px]" /></a>

                {/* Welcome Text */}
                <h2 className="text-2xl font-semibold text-gray-800 mb-[10px]">Welcome to Fatix Wax</h2>
                {/* <p className="phone-must-number1 mb-[35px]">After successful sign up check email for verification url to sign in </p> */}

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={({ confirmpassword, ...values }) => mutate(values)}
                >
                    {({
                        values,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                placeholder="FirstName"
                                name="firstName"
                                className="w-full border p-3 rounded-md mb-[35px] focus:outline-none focus:ring-2 focus:ring-green-500"
                                value={values.firstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <ErrorMessage
                                name="firstName"
                                component="div"
                                className="text-red-500"
                            />

                            <input
                                type="text"
                                placeholder="LastName"
                                name="lastName"
                                className="w-full border p-3 rounded-md mb-[35px] focus:outline-none focus:ring-2 focus:ring-green-500"
                                value={values.lastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <ErrorMessage
                                name="lastName"
                                component="div"
                                className="text-red-500"
                            />
                            {/* Email Input */}
                            <input
                                type="email"
                                placeholder="Email"
                                name="email"
                                className="w-full border p-3 rounded-md mb-[35px] focus:outline-none focus:ring-2 focus:ring-green-500"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <ErrorMessage
                                name="email"
                                component="div"
                                className="text-red-500"
                            />
                            <p className="phone-must-number">Phone Number must be in international format i.e (+234 ******) </p>
                            <input
                                type="text"
                                placeholder="Phone Number"
                                name="phoneNumber"
                                value={values.phoneNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className="w-full border p-3 rounded-md mb-[35px] focus:outline-none focus:ring-2 focus:ring-green-500"
                            />

                            <ErrorMessage
                                name="phoneNumber"
                                component="div"
                                className="text-red-500"
                            />

                            {/* Password Input */}
                            <div className="has-pwd-icon">
                                <input
                                    name="password"
                                    placeholder="Password"
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type={visible ? "text" : "password"}
                                    className="w-full border p-3 rounded-md mb-[10px] focus:outline-none focus:ring-2 focus:ring-green-500"
                                />
                                {visible ? (
                                    <BsEye
                                        className="view-pwd4"
                                        size={20}
                                        onClick={() =>
                                            setVisible(
                                                (prevState) =>
                                                    !prevState
                                            )
                                        }
                                    />
                                ) : (
                                    <BsEyeSlash
                                        className="view-pwd4"
                                        size={20}
                                        onClick={() =>
                                            setVisible(
                                                (prevState) =>
                                                    !prevState
                                            )
                                        }
                                    />
                                )}
                                <ErrorMessage
                                    name="password"
                                    component="div"
                                    className="text-red-500"
                                />
                            </div>

                            {/* Password Input */}
                            <div className="has-pwd-icon">
                                <input
                                    type={visible1 ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    name="confirmpassword"
                                    value={values.confirmpassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="w-full border p-3 rounded-md mb-[10px] mt-[25px] focus:outline-none focus:ring-2 focus:ring-green-500"
                                />

                                {visible1 ? (
                                    <BsEye
                                        className="view-pwd2"
                                        size={20}
                                        onClick={() =>
                                            setVisible1(
                                                (prevState) =>
                                                    !prevState
                                            )
                                        }
                                    />
                                ) : (
                                    <BsEyeSlash
                                        className="view-pwd2"
                                        size={20}
                                        onClick={() =>
                                            setVisible1(
                                                (prevState) =>
                                                    !prevState
                                            )
                                        }
                                    />
                                )}
                                <ErrorMessage
                                    name="confirmpassword"
                                    component="div"
                                    className="text-red-500"
                                />
                            </div>


                            {/* Login Button */}

                            <button className="w-full text-white p-3 rounded-md transition login-up-btn mt-[25px]">
                                Sign Up
                            </button>

                            {/* Sign Up Link */}
                            <p className="mt-4 text-gray-600">
                                Don't have an account? <a href="/login" className="text-green-600 font-semibold">Login</a>
                            </p>

                        </form>
                    )}
                </Formik>
            </div>

            {/* Right Section - col-lg-8 */}
            {/* Right Section - col-lg-8 */}
            <div className="hidden lg:flex w-2/3 out-of-pocket-bg p-[50px] relative">
                <img
                    src={popularTwo}
                    alt="Login Illustration"
                    className="w-full h-full object-cover"
                />

                {/* Text Overlay */}
                <div className="absolute bottom-[120px] left-1/2 transform -translate-x-1/2 bg-white bg-opacity-20 backdrop-blur-md border border-white rounded-lg px-6 py-[30px] text-center shadow-lg">
                    <h2 className="text-lg font-semibold text-gray-900 welcome-sub-header">Bringing Bold Style to Life</h2>
                    <p className="text-sm text-gray-700 welcome-sub-header-sub">Fabrics That Inspire Your Creative Vision , More Than Just Fabric — A Story Behind Every Piece</p>
                </div>
            </div>

        </div>
    );
};

export default Register;
